module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.set_headers
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin-top": "1em",
      "text-align": "left"
    }
  }, [_c('h4', [_vm._v("Join " + _vm._s(_vm.group.name))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._v("bb\r\n                " + _vm._s(_vm.group_details) + "\r\n            ")])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin-top": "2em",
      "text-align": "center"
    }
  }, [_c('p', [_vm._v("Sign in for a personalised tribe experience")]), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "margin": "1em"
    },
    attrs: {
      "href": "/login"
    }
  }, [_vm._v("login")]), _vm._v(" - \r\n                    "), _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "margin": "1em"
    },
    attrs: {
      "href": "/register"
    }
  }, [_vm._v("signup")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin-top": "2em",
      "text-align": "center"
    }
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("continue without signing in")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5657ad3e"}!./src/pages/Onboarding/template.html
// module id = 582
// module chunks = 0